import { render } from "./mvt-cardhouselist.vue?vue&type=template&id=5325a538"
import script from "./mvt-cardhouselist.js?vue&type=script&lang=js"
export * from "./mvt-cardhouselist.js?vue&type=script&lang=js"

import "./mvt-cardhouselist.vue?vue&type=style&index=0&id=5325a538&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__